/* eslint-disable */
import { ajax } from "noquery-ajax";
import { httpsLogger } from "../p1s7/p1s7e1";

interface Arguments {
  recycler_uid: string;
  recycler_location_uid: string;
  consumer_uid: string;
  conversation_uid: string;
  fs36_doc_id: string;
}

function createIdentityVerificationLink({
  recycler_uid,
  recycler_location_uid,
  consumer_uid,
  conversation_uid,
  fs36_doc_id
}: Arguments) {
  return new Promise(function (resolve, reject) {
    let params = {
      firebase_uid: window.G_firebase_auth.IV_uid,
      firebase_token: window.G_firebase_auth.IV_id_token,
      recycler_uid: recycler_uid,
      recycler_location_uid: recycler_location_uid,
      consumer_contact_uid: consumer_uid,
      conversation_uid: conversation_uid,
      p1s7e2_fs36_doc_id: fs36_doc_id
    };

    ajax({
      url: window.G_cloud_functions_base_url + "p1s7e2CreateIdentityVerificationLink",
      headers: {
        Accept: "application/json",
      },
      method: "POST",
      dataType: "json",
      data: params,
      success: function (result) {
        let response_data = {
          success: true,
          response: result,
          request_params: params
        }
        resolve(response_data);
      },
      error: function (error) {
        let error_data = {
          success: false,
          request_object: error,
          request_params: params,
          file_name: "p1s7e2.ts",
          class_name: "p1s7e2",
          method_name: "createIdentityVerificationLink",
          error_title: "Failed to create indentity verification link.",
          error_description: "The server responded with an error when requesting create indentity verification link.",
        };

        httpsLogger(error_data);
        reject(error_data);
      },
    });
  });
}

export default createIdentityVerificationLink;
